<div class="navbar-container" xmlns="http://www.w3.org/1999/html">
	<mat-toolbar color="primary" class="mat-elevation-z1">
		<button class="btn btn-link text-white" id="menu" (click)="toggleLeftSidenav()" *ngIf="isSideNavAvailable()">
			<mat-icon fontSet="fa" fontIcon="fa-bars"></mat-icon>
		</button>
		<button (click)="myPrograms()" color="accent" class="btn btn-link" id="menu">
			<img class="image-icon-md rounded-2" src="content/images/ibp_logo.jpg" alt="">
		</button>
		<span class="fs-2 font-weight-bold">{{program?.name}}</span>
		<div class="toolbar-filler"></div>
		<button class="btn btn-link text-white font-weight-bold fs-5" (click)="siteAdmin()" *jhiHasAnyAuthority="SITE_ADMIN_PERMISSIONS" data-test="siteAdminButton" jhiTranslate="navbar.site.admin">Site Admin</button>
		<button class="btn btn-link text-white font-weight-bold fs-5" *ngIf="toolLinkSelected" (click)="myPrograms()" data-test="myProgramsButton" jhiTranslate="navbar.my.programs">My Programs</button>
        <button class="btn btn-link text-white font-weight-bold fs-5" (click)="fieldMapManager()" *jhiHasAnyAuthority="FIELDMAP_MANAGER_PERMISSIONS" jhiTranslate="navbar.fieldmap.manager"></button>
		<ng-container *ngIf="!toolLinkSelected">
			<button class="btn btn-link text-white fs-5"  (click)="addProgram()" *jhiHasAnyAuthority="ADD_PROGRAM_PERMISSION" data-test="addProgramButton" jhiTranslate="navbar.add.program"><i class="fa fa-plus"></i></button>
		</ng-container>

		<button class="btn btn-link text-white" (click)="about()">
            <i class="fa fa-info"></i>
		</button>

		<a class="btn btn-link text-white"  href="{{aboutBMSHelpLink}}" target="_blank">
            <i class="fa fa-question-circle"></i>
		</a>

		<a class="btn btn-link text-white"  href="{{askForSupportHelpLink}}" target="_blank">
            <i class="fa fa-comments"></i>
		</a>

        <div class="ml-2">
            <jhi-languange-selector></jhi-languange-selector>
        </div>

        <div class="dropdown">
            <!-- Dropdown trigger button -->
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-outline-info text-white" ngbDropdownToggle type="button" id="memberMenu" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa fa-user"></i> {{user?.username}}
                </button>
                <!-- Dropdown menu -->
                <ul ngbDropdownMenu aria-labelledby="memberMenu">
                    <li>
                        <div class="px-3 py-2">
                            <button class="btn btn-outline-info d-flex align-items-center" (click)="openMyProfile()" data-test="openUserProfileButton">
                                <i class="fa fa-pencil-square"></i>
                                <span class="ms-2">{{user?.firstName}} {{user?.lastName}}</span>
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="px-3">
                            <h6 class="mb-2">{{user?.email}}</h6>
                        </div>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li>
                        <button class="btn btn-primary ms-3 mb-2" (click)="logout()" data-test="signOutButton" jhiTranslate="navbar.signout">
                            <i class="fa fa-sign-out"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </div>

    </mat-toolbar>
	<mat-sidenav-container class="sidenav-container">
		<mat-sidenav #sideNav mode="side" [opened]="leftSidenavOpen" *ngIf="isSideNavAvailable()"
					 fixedInViewport="true" fixedTopGap="40" fixedBottomGap="20" class="custom-scroll-style">
			<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
				<!-- This is the tree node template for expandable nodes -->
				<mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodeToggle>
					<button mat-icon-button [attr.aria-label]="'Toggle ' + node.name">
						<mat-icon class="mat-icon-rtl-mirror" fontSet="fa"
								  [fontIcon]="treeControl.isExpanded(node) ? 'fa-caret-down' : 'fa-caret-right'">
						</mat-icon>
					</button>
					{{node.nameTranslationKey | translate}}
				</mat-tree-node>
				<!-- This is the tree node template for leaf nodes -->
				<mat-tree-node class="leaf" [class.selected]="toolLinkSelected.startsWith(node.link)"
							   *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="34"
							   (click)="openTool({url: node.link, toolName: node.name})">
                    {{node.nameTranslationKey | translate}}
				</mat-tree-node>
			</mat-tree>
			<div *ngIf="version" class="version">{{version}}</div>
		</mat-sidenav>
		<mat-sidenav-content class="custom-scroll-style">
			<router-outlet></router-outlet>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>
